// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f72384a9","link":"ed0a2674"};